<template>
  <div class="purchase_order">
    <v-container grid-list-xl fluid>
      <v-layout wrap row>
        <v-flex xs12>
          <Title title="Farmer Invoice">
            <div slot="widget-content">
              <div>
                <p v-if="errors.length">
                  <v-alert
                    :value="true"
                    color="primary"
                    type="error"
                    dismissible
                    outline
                    >{{ errors }}</v-alert
                  >
                </p>

                <p v-if="pdferrors.length">
                  <v-alert
                    :value="true"
                    color="primary"
                    type="error"
                    dismissible
                    outline
                    >{{ pdferrors }}</v-alert
                  >
                </p>
                <v-layout wrap row>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color: #0cabc2">Action</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-flex xs2>
                    <v-dialog
                      v-model="new_invoice_po_dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <!-- <v-btn color="primary" slot="activator">New Invoice</v-btn> -->

                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-toolbar-title>New Invoice</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn
                              icon
                              dark
                              @click="new_invoice_po_dialog = false"
                            >
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>
                        <direct_farmer_invoice
                          @update="fetch_invoice_date_picker()"
                        ></direct_farmer_invoice>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs2>
                    <v-dialog
                      v-model="po_to_invoice_dialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                    >
                      <v-btn color="primary" slot="activator"
                        >PO to invoice</v-btn
                      >

                      <v-card>
                        <v-toolbar dark color="primary">
                          <v-toolbar-title>PO to Invoice</v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-toolbar-items>
                            <v-btn
                              icon
                              dark
                              @click="po_to_invoice_dialog = false"
                            >
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-toolbar-items>
                        </v-toolbar>

                        <PoToInvoice
                          @popup="popup"
                          @update="fetch_invoice_date_picker()"
                        ></PoToInvoice>
                      </v-card>
                    </v-dialog>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs12>
                    <v-divider></v-divider>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-toolbar flat color="white">
                    <v-toolbar-title>
                      <span style="color: #0cabc2">Previous Invoice</span>
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-flex xs9></v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="farmer"
                      :items="farmerList"
                      item-text="name"
                      item-value="name"
                      label="Farmer"
                      persistent-hint
                      small-chips
                      solo
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout wrap row>
                  <v-flex xs6></v-flex>
                  <v-flex xs6>
                    <datepicker
                      ref="datepicker"
                      @update="fetch_invoice_date_picker()"
                    ></datepicker>
                  </v-flex>
                </v-layout>

                <!-- <v-flex xs12>
                  <v-select
                    v-model="selected_do_to_invoice"
                    :items="do_list_array"
                    filled
                    item-text="id"
                    label="DOxx"
                    multiple
                  >
                    <template slot="item" slot-scope="{ item }">
                      {{ item.date }} &nbsp; &nbsp;
                      {{ item.prefix_id }} &nbsp; &nbsp;
                      {{ item.driver_name }} &nbsp; &nbsp;
                    </template>
                  </v-select>
                </v-flex>-->
                <v-layout>
                  <v-btn color="warning" v-if="selected.length>0" @click="fetch_array_for_bulk_print()">print</v-btn>
                </v-layout>
                <v-data-table
                  :headers="headers_invoice"
                  :items="invoice_list_array"
                  :search="farmer"
                  :disable-initial-sort="true"
                  hide-actions
                  active-class="highlighted"
                  class="elevation-5"
                  select-all
                  v-model="selected"
                >
                  <template v-slot:headers="props">
                    <tr>
                      <th>
                        <v-checkbox
                          :input-value="props.all"
                          :indeterminate="props.indeterminate"
                          primary
                          hide-details
                          @click.stop="toggleAll"
                        ></v-checkbox>
                      </th>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                      ></th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props">
                    <tr
                      :active="props.selected"
                      @click="props.selected = !props.selected"
                    >
                      <td  width="4%">
                        <v-checkbox
                          :input-value="props.selected"
                          primary
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td width="8%" class="text-xs">
                        <b>{{ props.item.date }}</b>
                      </td>
                      <td width="10%" class="text-xs">
                        <b>{{ props.item.farmer_name }}</b>
                      </td>
                      <td width="5%" class="text-xs">
                        <b>{{ props.item.prefix_id }}</b>
                      </td>
                      <td width="10%" class="text-xs">
                        <b>{{ props.item.range }}</b>
                      </td>
                      <td width="15%" class="text-xs">
                        <v-layout class="ma-1">
                          <v-text-field
                            outline
                            label="Sewa Price"
                            type="number"
                            v-model="props.item.sewa_price"
                          ></v-text-field>
                          <v-btn
                            small
                            color="success"
                            outline
                            @click="
                              update_sewa(props.item.id, props.item.sewa_price)
                            "
                            >update</v-btn
                          >
                        </v-layout>
                      </td>
                      <td width="20%" class="text-xs">
                        <v-btn
                          @click="
                            fetch_sewa_for_print(
                              props.item.id,
                              props.item.farmer_name,
                              props.item.prefix_id,
                              props.item.range,
                              props.item.date
                            )
                          "
                          >print Sewa</v-btn
                        >
                        <v-btn
                          @click="
                            fetch_array_for_print(
                              props.item.id,
                              props.item.farmer_name,
                              props.item.prefix_id,
                              props.item.range,
                              props.item.date
                            )
                          "
                          >print Invoice</v-btn
                        >
                        <v-btn
                          @click="
                            fetch_array_for_statement(
                              props.item.id,
                              props.item.farmer_name,
                              props.item.prefix_id,
                              props.item.range,
                              props.item.date
                            )
                          "
                          >statement</v-btn
                        >
                      </td>
                      <td width="6%" class="text-xs">
                        <v-icon
                          medium
                          color="warning"
                          @click="editItem(props.item.id, props.item.farmer_id)"
                          >build</v-icon
                        >
                        <v-icon
                          medium
                          color="error"
                          @click="delete_invoice(props.item.id)"
                          >delete_forever</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-snackbar v-model="snackbar" :top="true">
                  No Internet Connection
                  <v-btn color="pink" flat @click="snackbar = false"
                    >Close</v-btn
                  >
                </v-snackbar>
              </div>
            </div>
          </Title>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog_invoice_item">
      <v-card>
        <v-card-title>
          <span class="headline">Invoice Item</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 lg12 sm12 md12>
                <invoice_to_po_table
                  ref="invoice_to_po_table"
                ></invoice_to_po_table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="po_item_dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar when axios method responsed  (jump out at bottom) -->
    <v-snackbar
      v-model="snackbar_response"
      :bottom="true"
      :multi-line="true"
      :timeout="5000"
    >
      {{ response_detail }}
      <v-btn color="primary" flat @click="snackbar_response = false"
        >Close</v-btn
      >
    </v-snackbar>

    <!-- Snackbar when axios method error catched  (jump out at top) -->
    <v-snackbar v-model="snackbar_no_connection" :top="true" :timeout="6000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar_connection = false"
        >Close</v-btn
      >
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Title from "@/components/widget/title";
import direct_farmer_invoice from "@/components/large_component/direct_farmer_invoice";
import invoice_to_po_table from "@/components/large_component/invoice_to_po_table";
import PoToInvoice from "@/components/large_component/po_to_invoice";
import datepicker from "@/components/widget/datepicker";

export default {
  components: {
    //  small_list,
    Title,
    direct_farmer_invoice,
    invoice_to_po_table,
    datepicker,
    PoToInvoice,
  },
  data: () => ({
    selected_po_to_invoice: [],
    search: "",
    isLoading: true,
    snackbar: false,
    errors: "",
    pdferrors: "",
    refresh: true,
    baseUrl: baseUrl,
    date_now: moment().format("DD-MM-YYYY"),
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
    selected_farmer_name: "",
    selected_farmer_address: "",
    selected_driver_name: "",
    selected_po_id: "",
    VegeLogo: "",
    CheckBox: "",
    date_box: false,
    headers_invoice: [
      { text: "Date", align: "left", value: "date" },
      { text: "Farmer", align: "left", value: "farmer_name" },
      { text: "ID", align: "left", value: "prefix_id" },
      { text: "Range", align: "left", value: "range" },
      { text: "Print", align: "left", value: "" },
      { text: "Tool", align: "left", value: "" },
    ],
    selected: [],
    date: moment().format("YYYY-MM-DD"),
    farmerList: [],
    farmer: "",
    po_item_dialog: false,
    headers: [
      { text: "ID", align: "", value: "prefix_id" },
      { text: "Date", align: "", value: "date" },
      { text: "Driver", align: "", value: "driver_name" },
    ],
    // tablearray: [
    //   {
    //     product_name: "",
    //     grade: "",
    //     location: "",
    //     weight: "",
    //     quantity: "",
    //     price: "",
    //     row_price: ""
    //   }
    // ],
    po_list_array: [],
    invoice_list_array: [],
    fetched_one_po_array: [],
    invoice_array_for_print: [],
    bulk_invoice_array_for_print:[],
    sewa_array_for_print: [],
    prefix_id: "",
    farmer_name: "",
    range: "",
    invoice_created_date: "",
    new_po_dialog: false,
    po_to_invoice_dialog: false,
    dialog_invoice_item: false,
    name: "",
    address: "",
    phone: "",
    fax: "",
    setting_grade: true,
    setting_location: true,
    setting_price: true,
    stocked_day_limit: "",
    new_invoice_po_dialog: false,
    snackbar_response: false,
    snackbar_no_connection: false,
    //others
    response: "",
    response_detail: "",
    formatted_array2: [],
  }),

  computed: {},

  watch: {},

  created() {
    this.getFarmer();
    this.fetch_invoice(this.start_date, this.end_date);
    this.getImageLogo();
    this.getCompanyInfo();
  },

  methods: {
    getFarmer() {
      const params = new URLSearchParams();
      params.append("get_farmer", "1");
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/stock_farmer.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            this.farmerList = response.data.data;
          } else if (response.data.error == true) {
            console.log("farmer List Problem" + response.data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar_connection = true;
        });
    },

    fetch_po: function () {
      const params = new URLSearchParams();
      params.append(
        "getPurchaseOrderListForInvoice",
        "getPurchaseOrderListForInvoice"
      );
      params.append("farmer_id", this.farmer);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.po_list_array = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.po_list_array = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    create_invoice: function () {
      const params = new URLSearchParams();
      params.append("createInvoice", "getDeliveryOrderList");
      params.append("farmer_id", this.farmer);
      params.append("po_id", this.selected_po_to_invoice);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.po_list_array = response.data.data;
            this.fetch_invoice();
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.po_list_array = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_invoice_date_picker() {
      this.fetch_invoice(
        this.$refs.datepicker.date1,
        this.$refs.datepicker.date2
      );
    },
    fetch_invoice: function (start_date, end_date) {
      this.po_to_invoice_dialog = false;
      const params = new URLSearchParams();
      params.append("getInvoiceList", "getDeliveryOrderList");
      params.append("start_date", start_date);
      params.append("end_date", end_date);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            console.log(response.data);

            this.snackbar = false;
            this.invoice_list_array = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.invoice_list_array = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    get_po_detail(po_id) {
      this.$refs.po_table.getPOStock(po_id);
      this.po_item_dialog = true;
    },
    editItem(id, farmer_id) {
      console.log("hehe");
      this.dialog_invoice_item = true;
      this.$refs.invoice_to_po_table.getInvoiceItem(id, farmer_id);
    },
    fetch_array_for_print(invoice_id, farmer_name, prefix_id, range, date) {
      this.prefix_id = prefix_id;
      this.farmer_name = farmer_name;
      this.range = range;
      this.invoice_created_date = date;
      const params = new URLSearchParams();
      params.append("fetch_invoice_array", "fetch_invoice_array");
      params.append("invoice_id", invoice_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.invoice_array_for_print = response.data.data;
            this.print_invoice(invoice_id, farmer_name, date);
            // var item = this.invoice_array_for_print[0].item;
            // var item2 = this.invoice_array_for_print[0].subtotal;

            // var items= item.split(';');

            //  for(var i = 0; i < items.length; i++){
            //    var name = items[i].split(',');
            //  var id = name[0];
            //   var prodcut = name[1];
            //   console.log(prodcut);
            // }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.invoice_array_for_print = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },

    fetch_array_for_bulk_print() {
     
      const params = new URLSearchParams();
      params.append("fetch_invoices_array", "fetch_invoices_array");
      params.append("bulk_invoice_id", JSON.stringify(this.selected));
          console.log(this.selected);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params,
      })
        .then((response) => {
          console.log('ok');

          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.bulk_invoice_array_for_print = response.data.data;
            this.print_bulk_invoice();
            // var item = this.invoice_array_for_print[0].item;
            // var item2 = this.invoice_array_for_print[0].subtotal;

            // var items= item.split(';');

            //  for(var i = 0; i < items.length; i++){
            //    var name = items[i].split(',');
            //  var id = name[0];
            //   var prodcut = name[1];
            //   console.log(prodcut);
            // }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.bulk_invoice_array_for_print = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    fetch_sewa_for_print(invoice_id, farmer_name, prefix_id, range, date) {
      const params = new URLSearchParams();
      params.append("sewa", "sewa");
      params.append("invoice_id", invoice_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == false) {
            this.snackbar = false;
            this.sewa_array_for_print = response.data.data;
            // console.log( JSON.stringify( this.sewa_array_for_print));

            this.print_sewa(invoice_id, farmer_name, prefix_id, range, date);
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.sewa_array_for_print = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    print_sewa(invoice_id, farmer_name, prefix_id, range, date) {
      var total_sewa = 0;

      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "NO: ");
      doc.text(158, 20, "Date: ");
      doc.text(148, 25, "Farmer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#" + invoice_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(farmer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(11);
      doc.setFontStyle("normal");
      doc.text(15, 45, "Farmer Vege Date(Sewa):");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(65, 45, range);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "Date", dataKey: "date" },
        { header: "Total KG", dataKey: "total_weight" },
        { header: "Price per KG", dataKey: "sewa_price" },
        { header: "Amount", dataKey: "sub_total" },
      ];

      for (var g = 0; g < this.sewa_array_for_print.length; g++) {
        var sub_total = this.sewa_array_for_print[g].sub_total;
        total_sewa = total_sewa + parseFloat(sub_total > -1 ? sub_total : null);

        this.sewa_array_for_print[g].sewa_price =
          "RM" + parseFloat(this.sewa_array_for_print[g].sewa_price).toFixed(2);
        this.sewa_array_for_print[g].total_weight =
          parseFloat(
            this.sewa_array_for_print[g].total_weight > -1
              ? this.sewa_array_for_print[g].total_weight
              : "0"
          ) + "kg";
        this.sewa_array_for_print[g].sub_total =
          "RM" +
          parseFloat(
            this.sewa_array_for_print[g].sub_total > -1
              ? this.sewa_array_for_print[g].sub_total
              : "0"
          ).toFixed(2);
      }

      console.log(total_sewa);
      doc.autoTable({
        pageBreak: "auto",
        startY: 55,
        theme: "grid",

        headStyles: {
          fillColor: [224, 224, 224],
          textColor: 10,
          fontSize: 11,
        },

        columnStyles: {
          total_weight: { date: 15 },
          total_weight: { columnWidth: 30 },
          sewa_price: { columnWidth: 30 },
          sub_total: { columnWidth: 10, fontStyle: "bold", fontSize: 12 },
        },
        columns: invoice_pdf_header,
        body: this.sewa_array_for_print,
      });

      //////after auto table

      if (doc.autoTable.previous.finalY > 230) {
        doc.addPage();
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          20,
          "Total Amount: RM" + parseFloat(total_sewa).toFixed(2)
        );

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 25, 192, 25);

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(140, 42, 192, 42);

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, 47, "Name:");
        doc.text(140, 51, "Date:");
      } else {
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          doc.autoTable.previous.finalY + 20,
          "Total Amount: RM" + parseFloat(total_sewa).toFixed(2)
        );

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(
          140,
          doc.autoTable.previous.finalY + 42,
          192,
          doc.autoTable.previous.finalY + 42
        );

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        doc.text(140, doc.autoTable.previous.finalY + 51, "Date:");
      }

      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      doc.save("F_Invoice(sewa)-" + farmer_name + "-" + date + ".pdf");
    },
    getImageLogo() {
      const toDataURL = (url) =>
        fetch(url)
          .then((response) => response.blob())
          .then(
            (blob) =>
              new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              })
          );

      toDataURL(require("@/assets/image/vege_trading.jpg")).then((dataUrl) => {
        this.VegeLogo = dataUrl;
      });

      toDataURL(require("@/assets/image/checkbox.png")).then((dataUrl) => {
        this.CheckBox = dataUrl;
      });
    },
    getCompanyInfo() {
      const params = new URLSearchParams();
      params.append("get_company_info", "get_company_info");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/setting.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            this.name = response.data.name;
            this.address = response.data.address;
            this.phone = response.data.phone;
            this.fax = response.data.fax;
            this.setting_grade = response.data.setting_grade;
            this.setting_location = response.data.setting_location;
            this.setting_price = response.data.setting_price;
            this.stocked_day_limit = response.data.stocked_day_limit;
          } else if (response.data.error == true) {
            console.log("gg");
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    find(
      product_id,
      product_name,
      product_type,
      grade,
      location,
      weight,
      quantity,
      price,
      row_price,
      total_weight_after_deduction,
      po_id,
      ref_no
    ) {
      for (var g = 0; g < this.formatted_array2.length; g++) {
        if (
          this.formatted_array2[g].grade == grade &&
          this.formatted_array2[g].po_id == po_id &&
          this.formatted_array2[g].location == location &&
          this.formatted_array2[g].product_id == product_id &&
          parseFloat(this.formatted_array2[g].price).toFixed(2) ==
            parseFloat(price).toFixed(2)
        ) {
          for (var j = 0; j < quantity; j++) {
            this.formatted_array2[g].weight =
              this.formatted_array2[g].weight + "," + weight;
            this.formatted_array2[g].quantity++;
          }
          this.formatted_array2[g].row_price =
            parseFloat(this.formatted_array2[g].row_price) +
            parseFloat(row_price);
          this.formatted_array2[g].total_weight_after_deduction =
            parseFloat(this.formatted_array2[g].total_weight_after_deduction) +
            parseFloat(total_weight_after_deduction);
          return;
        }
      }

      var single_weight = "";

      for (var i = 0; i < quantity; i++) {
        single_weight =
          (single_weight == "" ? "" : single_weight + ",") + weight;
      }

      if (!ref_no == null || !ref_no == "") {
        po_id = ref_no;
      }

      for (var a = 0; a < this.formatted_array2.length; a++) {
        if (this.formatted_array2[a].po_id == po_id) {
          po_id = "";
        }
      }

      this.formatted_array2.push({
        product_id: product_id,
        product_name: product_name,
        grade: grade,
        location: location,
        quantity: quantity,
        weight: single_weight,
        price: price,
        row_price: row_price,
        total_weight_after_deduction: total_weight_after_deduction,
        po_id: po_id,
      });
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.invoice_list_array.slice();
    },
    print_invoice(invoice_id, farmer_name, date) {
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(10);
      doc.setFontStyle("bold");
      doc.text(131, 15, "PURCHASE INVOICE: ");
      doc.setFontSize(11);
      doc.text(158, 20, "Date: ");
      doc.text(153, 25, "Farmer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "" + invoice_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, this.invoice_created_date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(this.farmer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(15, 45, "Purchase Bill:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(55, 45, this.range);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "PO", dataKey: "po_id" },
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        // { header: "Qty", dataKey: "quantity" },
        { header: "Price/KG", dataKey: "price" },
        { header: "Total Kg/box", dataKey: "total_weight_after_deduction" },
        { header: "Amount", dataKey: "row_price" },
      ];

      var grade_array = { header: "Grade", dataKey: "grade" };
      var location_array = { header: "Location", dataKey: "location" };

      // if (localStorage.setting_location == "true") {
      //   invoice_pdf_header.splice(3, 0, location_array);
      // }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(3, 0, grade_array);
      }

      for (var g = 0; g < this.invoice_array_for_print.length; g++) {
        var items = this.invoice_array_for_print[g].item;
        var date = this.invoice_array_for_print[g].date;

        var item = items.split(";");
        var subtotal = 0;
        var tablearray = [];
        var row_no = 1;
        this.formatted_array2 = [];

        for (var i = 0; i < item.length; i++) {
          var veg = item[i].split(",");
          var product_id = veg[0];
          var product_name = veg[1];
          var product_type = veg[2];
          var grade = veg[3];
          var location = veg[4];
          var weight = veg[5];
          var quantity = veg[6];
          var price = parseFloat(veg[7]).toFixed(2);
          var total_weight = veg[8];
          var total_weight_after_deduction = veg[9];
          var row_price = parseFloat(veg[10]).toFixed(2);
          var po_id = parseFloat(veg[11]);
          var ref_no = veg[12];
          console.log(ref_no);

     

          this.find(
            product_id,
            product_name,
            product_type,
            grade,
            location,
            weight,
            quantity,
            price,
            row_price,
            total_weight_after_deduction,
            po_id,
            ref_no
          );

          subtotal = subtotal + parseFloat(row_price);

          // tablearray.push({
          //   row_no: row_no,
          //   product_name: product_name,
          //   grade: grade,
          //   location: location,
          //   weight: weight + product_type,
          //   quantity: quantity,
          //   price: "RM" + price,
          //   total_real_weight: total_real_weight,
          //   rowprice: "RM" + parseFloat(row_price).toFixed(2)
          // });
          // row_no = row_no + 1;
        }

        if (
          doc.autoTable.previous.finalY > 0 &&
          doc.autoTable.previous.finalY <= 200
        ) {
          nextstart = doc.autoTable.previous.finalY + 20;

          console.log("1");
        } else if (doc.autoTable.previous.finalY > 200) {
          doc.addPage();
          nextstart = 34;
          console.log("2");
        } else {
          nextstart = 65;
          console.log("3");
        }

        doc.setFontSize(11);
        doc.setFontStyle("bold");
        doc.text(15, nextstart - 3, date);

        doc.setLineWidth(0.1);
        doc.setDrawColor(0, 0, 0);
        doc.line(15, nextstart - 1, 35, nextstart - 1);

        for (var i = 0; i < this.formatted_array2.length; i++) {
          this.$set(this.formatted_array2[i], "row_no", i + 1);
          this.formatted_array2[i].row_price = parseFloat(
            this.formatted_array2[i].row_price
          ).toFixed(2);
        }

        doc.autoTable({
          pageBreak: "auto",
          startY: nextstart,
          didDrawPage: function (data) {
            // Header
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle("normal");

            // Footer
            var str = "Page " + doc.internal.getNumberOfPages();
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === "function") {
              str = str;
            }
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            doc.text(str, 100, pageHeight - 10);
          },
          theme: "grid",
          showHead: "firstPage",
          headStyles: {
            fillColor: [224, 224, 224],
            textColor: 10,
            fontSize: 11,
          },

          columnStyles: {
            po_id: { columnWidth: 14, fontStyle: "bold" },
            row_no: { columnWidth: 7, fontStyle: "bold" },
            product_name: { columnWidth: 15, fontStyle: "bold" },
            grade: { columnWidth: 6 },
            location: { columnWidth: 7 },
            weight: { columnWidth: 35 },
            quantity: { columnWidth: 5 },
            price: { columnWidth: 8 },
            total_weight_after_deduction: { columnWidth: 8 },
            rowprice: { columnWidth: 8, fontStyle: "bold" },
          },
          columns: invoice_pdf_header,
          body: this.formatted_array2,
        });

        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          168,
          doc.autoTable.previous.finalY + 5,
          "RM" + parseFloat(subtotal).toFixed(2)
        );

        total = total + subtotal;
      }
      nextstart = 0;
      //////after auto table

      if (doc.autoTable.previous.finalY > 210) {
        doc.addPage();
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(140, 20, "Total Amount: RM" + parseFloat(total).toFixed(2));

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 25, 192, 25);

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(140, 42, 192, 42);

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, 47, "Name:");
        doc.text(140, 51, "Date:");
      } else {
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          doc.autoTable.previous.finalY + 20,
          "Total Amount: RM" + parseFloat(total).toFixed(2)
        );

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(
          140,
          doc.autoTable.previous.finalY + 42,
          192,
          doc.autoTable.previous.finalY + 42
        );

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        doc.text(140, doc.autoTable.previous.finalY + 51, "Date:");
      }
      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      invoice_pdf_header = [
        { header: "PO", dataKey: "po_id" },
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Price ", dataKey: "price" },
        { header: "Total Kg/box", dataKey: "total_weight_after_deduction" },
        { header: "Amount", dataKey: "rowprice" },
      ];
      doc.save("F_Invoice-" + farmer_name + "-" + date + ".pdf");
    },
    print_bulk_invoice() {
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      // doc.text(162, 15, "NO: ");
      // doc.text(158, 20, "Date: ");
      // doc.text(153, 25, "Farmer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      // doc.text(170, 15, "#" + invoice_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      // doc.text(170, 20, this.invoice_created_date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      // var splitTitle = doc.splitTextToSize(this.farmer_name, 30);
      // doc.text(170, 25, splitTitle);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(15, 45, "Bulk print:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      // doc.text(55, 45, this.range);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      //////auto table
      var total = 0;
      var nextstart = 0;
      var invoice_pdf_header = [
        { header: "PO", dataKey: "po_id" },
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        // { header: "Qty", dataKey: "quantity" },
        { header: "Price/KG", dataKey: "price" },
        { header: "Total Kg/box", dataKey: "total_weight_after_deduction" },
        { header: "Amount", dataKey: "row_price" },
      ];

      var grade_array = { header: "Grade", dataKey: "grade" };
      var location_array = { header: "Location", dataKey: "location" };

      // if (localStorage.setting_location == "true") {
      //   invoice_pdf_header.splice(3, 0, location_array);
      // }
      if (localStorage.setting_grade == "true") {
        invoice_pdf_header.splice(3, 0, grade_array);
      }

      for (var g = 0; g < this.bulk_invoice_array_for_print.length; g++) {
        var items = this.bulk_invoice_array_for_print[g].item;
        var date = this.bulk_invoice_array_for_print[g].date;

        var item = items.split(";");
        var subtotal = 0;
        var tablearray = [];
        var row_no = 1;
        this.formatted_array2 = [];

        for (var i = 0; i < item.length; i++) {
          var veg = item[i].split(",");
          var product_id = veg[0];
          var product_name = veg[1];
          var product_type = veg[2];
          var grade = veg[3];
          var location = veg[4];
          var weight = veg[5];
          var quantity = veg[6];
          var price = parseFloat(veg[7]).toFixed(2);
          var total_weight = veg[8];
          var total_weight_after_deduction = veg[9];
          var row_price = parseFloat(veg[10]).toFixed(2);
          var po_id = parseFloat(veg[11]).toFixed(2);
          var ref_no = veg[12];
          console.log(ref_no);

          // var total_real_weight = "";

          // if (product_type == "box") {
          //   weight = "";
          // } else {
          //   product_type = "kg";
          //   total_weight = parseFloat(total_weight).toFixed(2);
          //   total_weight_after_deduction = parseFloat(
          //     total_weight_after_deduction
          //   ).toFixed(2);
          // }

          // if (total_weight != total_weight_after_deduction) {
          //   total_real_weight =
          //     total_weight_after_deduction +
          //     product_type +
          //     " (" +
          //     (total_weight - total_weight_after_deduction) +
          //     product_type +
          //     " deducted)";
          // } else {
          //   total_real_weight = total_weight + "" + product_type;
          // }

          this.find(
            product_id,
            product_name,
            product_type,
            grade,
            location,
            weight,
            quantity,
            price,
            row_price,
            total_weight_after_deduction,
            po_id,
            ref_no
          );

          subtotal = parseFloat(subtotal) + parseFloat(row_price);

          // tablearray.push({
          //   row_no: row_no,
          //   product_name: product_name,
          //   grade: grade,
          //   location: location,
          //   weight: weight + product_type,
          //   quantity: quantity,
          //   price: "RM" + price,
          //   total_real_weight: total_real_weight,
          //   rowprice: "RM" + parseFloat(row_price).toFixed(2)
          // });
          // row_no = row_no + 1;
        }

        if (
          doc.autoTable.previous.finalY > 0 &&
          doc.autoTable.previous.finalY <= 200
        ) {
          nextstart = doc.autoTable.previous.finalY + 20;

          console.log("1");
        } else if (doc.autoTable.previous.finalY > 200) {
          doc.addPage();
          nextstart = 34;
          console.log("2");
        } else {
          nextstart = 65;
          console.log("3");
        }

        doc.setFontSize(11);
        doc.setFontStyle("bold");
        doc.text(15, nextstart - 3, date);

        doc.setLineWidth(0.1);
        doc.setDrawColor(0, 0, 0);
        doc.line(15, nextstart - 1, 35, nextstart - 1);

        for (var i = 0; i < this.formatted_array2.length; i++) {
          this.$set(this.formatted_array2[i], "row_no", i + 1);
          this.formatted_array2[i].row_price = parseFloat(
            this.formatted_array2[i].row_price
          ).toFixed(2);
        }

        doc.autoTable({
          pageBreak: "auto",
          startY: nextstart,
          didDrawPage: function (data) {
            // Header
            doc.setFontSize(20);
            doc.setTextColor(40);
            doc.setFontStyle("normal");

            // Footer
            var str = "Page " + doc.internal.getNumberOfPages();
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === "function") {
              str = str;
            }
            doc.setFontSize(10);

            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize;
            var pageHeight = pageSize.height
              ? pageSize.height
              : pageSize.getHeight();
            doc.text(str, 100, pageHeight - 10);
          },
          theme: "grid",
          showHead: "firstPage",
          headStyles: {
            fillColor: [224, 224, 224],
            textColor: 10,
            fontSize: 11,
          },

          columnStyles: {
            po_id: { columnWidth: 14, fontStyle: "bold" },
            row_no: { columnWidth: 7, fontStyle: "bold" },
            product_name: { columnWidth: 15, fontStyle: "bold" },
            grade: { columnWidth: 6 },
            location: { columnWidth: 7 },
            weight: { columnWidth: 35 },
            quantity: { columnWidth: 5 },
            price: { columnWidth: 8 },
            total_weight_after_deduction: { columnWidth: 8 },
            rowprice: { columnWidth: 8, fontStyle: "bold" },
          },
          columns: invoice_pdf_header,
          body: this.formatted_array2,
        });

        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          168,
          doc.autoTable.previous.finalY + 5,
          "RM" + parseFloat(subtotal).toFixed(2)
        );

        total = parseFloat(total) + parseFloat(subtotal);
      }
      nextstart = 0;
      //////after auto table

      if (doc.autoTable.previous.finalY > 210) {
        doc.addPage();
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(140, 20, "Total Amount: RM" + parseFloat(total).toFixed(2));

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(15, 25, 192, 25);

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(140, 42, 192, 42);

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, 47, "Name:");
        doc.text(140, 51, "Date:");
      } else {
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          doc.autoTable.previous.finalY + 20,
          "Total Amount: RM" + parseFloat(total).toFixed(2)
        );

        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(
          15,
          doc.autoTable.previous.finalY + 25,
          192,
          doc.autoTable.previous.finalY + 25
        );

        doc.setFontSize(12);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 31, "RECIEVED:");

        doc.setLineWidth(0.1);
        doc.line(
          140,
          doc.autoTable.previous.finalY + 42,
          192,
          doc.autoTable.previous.finalY + 42
        );

        doc.setFontSize(10);
        doc.setFontStyle("normal");
        doc.text(140, doc.autoTable.previous.finalY + 47, "Name:");
        doc.text(140, doc.autoTable.previous.finalY + 51, "Date:");
      }
      // var img = "@/assets/image/broccoli.jpeg";
      doc.autoTable.previous.finalY = 0;
      invoice_pdf_header = [
        { header: "PO", dataKey: "po_id" },
        { header: "", dataKey: "row_no" },
        { header: "Vege", dataKey: "product_name" },
        // { header: "Grade", dataKey: "grade" },
        //{ header: "Location", dataKey: "location" },
        { header: "Weight", dataKey: "weight" },
        { header: "Qty", dataKey: "quantity" },
        { header: "Price ", dataKey: "price" },
        { header: "Total Kg/box", dataKey: "total_weight_after_deduction" },
        { header: "Amount", dataKey: "rowprice" },
      ];
      doc.save("Bulk_Invoice.pdf");
    },
    InvoiceCreated() {
      this.snackbar_response = true;
      this.response_detail = "created";
    },
    delete_invoice(invoice_id) {
      if (confirm("Delete invoice and release the stock?")) {
        const params = new URLSearchParams();
        params.append("delete_invoice", "delete_invoice");
        params.append("invoice_id", invoice_id);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
          data: params,
        })
          .then((response) => {
            if (response.data.error == false) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
              this.fetch_invoice(
                this.$refs.datepicker.date1,
                this.$refs.datepicker.date2
              );
            } else if (response.data.error == true) {
              this.snackbar_response = true;
              this.response_detail = response.data.message;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar = true;
          });
      }
    },
    update_sewa(invoice_id, sewa_price) {
      const params = new URLSearchParams();
      params.append("UpdateSewaPrice", "UpdateSewaPrice");
      params.append("invoice_id", invoice_id);
      params.append("sewa_price", sewa_price);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
            this.fetch_invoice(
              this.$refs.datepicker.date1,
              this.$refs.datepicker.date2
            );
          } else if (response.data.error == true) {
            this.snackbar_response = true;
            this.response_detail = response.data.message;
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    popup(e) {
      this.snackbar_response = true;
      this.response_detail = e;
    },
    fetch_array_for_statement(invoice_id, farmer_name, prefix_id, range, date) {
      this.prefix_id = prefix_id;
      this.farmer_name = farmer_name;
      this.range = range;
      this.invoice_created_date = date;
      const params = new URLSearchParams();
      params.append("fetch_invoice_array", "fetch_invoice_array");
      params.append("invoice_id", invoice_id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/farmer_invoice.php",
        data: params,
      })
        .then((response) => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.invoice_array_for_print = response.data.data;
            this.print_statement(invoice_id, farmer_name, date);
            // var item = this.invoice_array_for_print[0].item;
            // var item2 = this.invoice_array_for_print[0].subtotal;

            // var items= item.split(';');

            //  for(var i = 0; i < items.length; i++){
            //    var name = items[i].split(',');
            //  var id = name[0];
            //   var prodcut = name[1];
            //   console.log(prodcut);
            // }
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.invoice_array_for_print = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.snackbar = true;
        });
    },
    print_statement(invoice_id, farmer_name, date) {
      var doc = new jsPDF();

      // doc.addImage(this.VegeLogo, 15, 10, 23, 23);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(14, 15, localStorage.name);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(15, 20, localStorage.address);
      doc.text(15, 25, "Phone:" + localStorage.phone);
      doc.text(15, 30, "Fax: -" + localStorage.fax);

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(162, 15, "NO: ");
      doc.text(158, 20, "Date: ");
      doc.text(153, 25, "Farmer: ");

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      doc.text(170, 15, "#" + invoice_id);

      doc.setFontSize(10);
      doc.setFontStyle("normal");
      doc.text(170, 20, this.invoice_created_date);

      doc.setFontSize(12);
      doc.setFontStyle("bold");
      var splitTitle = doc.splitTextToSize(this.farmer_name, 30);
      doc.text(170, 25, splitTitle);

      doc.setFontSize(13);
      doc.setFontStyle("bold");
      doc.text(15, 45, "Statement:");

      doc.setFontSize(11);
      doc.setFontStyle("bold");
      doc.text(55, 45, this.range);
      doc.setLineWidth(0.3);
      doc.line(15, 47, 192, 47);

      //////auto table
      var total = 0;
      var nextstart = 0;

      for (var g = 0; g < this.invoice_array_for_print.length; g++) {
        var items = this.invoice_array_for_print[g].item;
        var date = this.invoice_array_for_print[g].date;

        var item = items.split(";");
        var subtotal = 0;
        var tablearray = [];
        var row_no = 1;
        this.formatted_array2 = [];

        for (var i = 0; i < item.length; i++) {
          var veg = item[i].split(",");
          var product_id = veg[0];
          var product_name = veg[1];
          var product_type = veg[2];
          var grade = veg[3];
          var location = veg[4];
          var weight = veg[5];
          var quantity = veg[6];
          var price = parseFloat(veg[7]).toFixed(2);
          var total_weight = veg[8];
          var total_weight_after_deduction = veg[9];
          var row_price = parseFloat(veg[10]);
          var po_id = parseFloat(veg[11]);
          var ref_no = veg[12];
          console.log(ref_no);

          this.find(
            product_id,
            product_name,
            product_type,
            grade,
            location,
            weight,
            quantity,
            price,
            row_price,
            total_weight_after_deduction,
            po_id,
            ref_no
          );

          subtotal = subtotal + row_price;

          // tablearray.push({
          //   row_no: row_no,
          //   product_name: product_name,
          //   grade: grade,
          //   location: location,
          //   weight: weight + product_type,
          //   quantity: quantity,
          //   price: "RM" + price,
          //   total_real_weight: total_real_weight,
          //   rowprice: "RM" + parseFloat(row_price).toFixed(2)
          // });
          // row_no = row_no + 1;
        }

        if (nextstart > 0 && nextstart <= 250) {
          nextstart = nextstart + 20;
        } else if (nextstart > 250) {
          doc.addPage();
          nextstart = 34;
          console.log("2");
        } else {
          nextstart = 65;
          console.log("3");
        }

        doc.setFontSize(11);
        doc.setFontStyle("bold");
        doc.text(15, nextstart - 3, date);

        doc.setLineWidth(0.1);
        doc.setDrawColor(0, 0, 0);
        doc.line(15, nextstart - 1, 35, nextstart - 1);

        for (var i = 0; i < this.formatted_array2.length; i++) {
          this.$set(this.formatted_array2[i], "row_no", i + 1);
          this.formatted_array2[i].row_price = parseFloat(
            this.formatted_array2[i].row_price
          ).toFixed(2);
        }

        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(15, nextstart + 5, "RM" + parseFloat(subtotal).toFixed(2));

        total = total + subtotal;
      }
      // nextstart = 0;
      //////after auto table

      if (nextstart > 250) {
        doc.addPage();
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(140, 20, "Total Amount: RM" + parseFloat(total).toFixed(2));
      } else {
        doc.setFontSize(12);
        doc.setFontStyle("bold");
        doc.text(
          140,
          nextstart + 20,
          "Total Amount: RM" + parseFloat(total).toFixed(2)
        );
      }
      // var img = "@/assets/image/broccoli.jpeg";
      nextstart = 0;

      doc.save("F_Invoice-" + farmer_name + "-" + date + ".pdf");
    },
  },
  mounted() {
    // Run the functions once when mounted
    // Run the intervalFetchData function once to set the interval time for later refresh
  },
};
</script>

